import Vue from 'vue';
import Amplify from 'aws-amplify';

import App from './App.vue';
import router from './router';
import store from './store';
import vuetify from './plugins/vuetify';
import { awsConfig } from '@/aws_config';
import './assets/style/style.scss';
import currencyFilter from '@/filters/currencyFilter';

Vue.config.productionTip = false;

Vue.prototype.$buckets = awsConfig.Storage.AWSS3.buckets;

Amplify.configure(awsConfig);

Vue.filter('currency', currencyFilter);

new Vue({
    store,
    router,
    vuetify,
    render: (h) => h(App),
}).$mount('#app');
